import template from './edit-realization.html';

class EditRealizationComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, moment,
    RealizationService,
    UtilService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.moment = moment;
    this.RealizationService = RealizationService;
    this.UtilService = UtilService;
  }

  $onInit() {
    this.startTime = this.realization.startTime;
    this.endTime = this.realization.endTime;
    this.date = this.moment(this.realization.date).toDate();
  }

  $onChanges(changes) {
    if (changes.realization) {
      this.realization = {...this.realization};
    }
  }

  edit(form) {
    if (form.$invalid) {
      return false;
    }

    this.realization.date = this.moment(this.date).format('YYYY-MM-DD');
    this.realization.startTime = this.startTime;
    this.realization.endTime = this.endTime;
    this.RealizationService.edit(
      {
        realization: this.realization
      }
    ).then(() => {
      this.$state.go('modules.realizations.byEmployee');
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Edytowano realizację')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const EditRealization = {
  bindings: {
    realization: '<'
  },
  template,
  controller: EditRealizationComponent
};
